import { addGroups, removeGroups } from '@/redux/util/announcement.util';
import {
	FETCH_ANNOUNCEMENTS,
	CLEAR_ANNOUNCEMENTS,
	CREATE_ANNOUNCEMENT,
	SEND_ANNOUNCEMENT,
	UPDATE_ANNOUNCEMENT,
	DELETE_ANNOUNCEMENT,
	ADD_GROUPS_TO_ANNOUNCEMENT,
	REMOVE_GROUPS_FROM_ANNOUNCEMENT,
} from '../actions/actionTypes';

const preState = [];

const announcementsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = [...state];
	const { type, announcements, announcement, announcementID, groupIDs } = action;
	switch (type) {
		case FETCH_ANNOUNCEMENTS:
			return [...announcements.nodes];
		case CLEAR_ANNOUNCEMENTS:
			return [];
		case CREATE_ANNOUNCEMENT:
			return [...stateDup, announcement];
		case SEND_ANNOUNCEMENT:
			return [...stateDup, announcement];
		case UPDATE_ANNOUNCEMENT:
			const updatedAnnouncements = stateDup.map(announce => {
				if (announce.id !== announcement.id) return announce;
				else return { ...announce, ...announcement };
			});
			return updatedAnnouncements;
		case DELETE_ANNOUNCEMENT:
			return stateDup.filter(announce => announce.id !== announcementID);
		case ADD_GROUPS_TO_ANNOUNCEMENT:
			return stateDup.map(announce => {
				if (announce.id !== announcementID) return announce;
				else return addGroups(groupIDs, announce);
			});
		case REMOVE_GROUPS_FROM_ANNOUNCEMENT:
			return stateDup.map(announce => {
				if (announce.id !== announcementID) return announce;
				else return removeGroups(groupIDs, announce);
			});
		default:
			return stateDup;
	}
};

export default announcementsReducer;
